/*
 * Created by Joseph Saliba on 5/27/17.
 */
import { Factory } from '../../services/Factory';
import angular from "angular";

namespace app.directives.controls {
  export interface IChildWindowScope extends angular.IScope {
  }

  export interface IChildWindowAttributes extends angular.IAttributes {
    template: string;
    toggle: string;
  }

  export class ChildWindow implements angular.IDirective {
    public restrict: string = 'A';
    public replace: boolean = false;
    public scope = false;
    public compile: angular.IDirectiveCompileFn;

    constructor($rootScope, $compile, $window, $templateCache, $parse) {
      this.compile = (element, attributes: IChildWindowAttributes) => {
        return {
          pre: (scope: IChildWindowScope) => {
            let childWindow;

            const unbindCallback = () => {
              $parse(attributes.toggle).assign($rootScope, false);

              $rootScope.$applyAsync();

              $rootScope.$broadcast(attributes.toggle, false);
            };

            const initializeChildWindowAsync = () => {
              childWindow.onunload = unbindCallback;

              // Copy all stylesheets from the parent window into the child.
              const childHead = childWindow.document.head;
              Array.from(document.head.querySelectorAll('link[rel="stylesheet"], style')).forEach(node => {
                childHead.appendChild(childWindow.document.importNode(node, true));
              });

              $compile(angular.element(childWindow.document).contents())(scope);

              // Re-trigger resource loading on the already-compiled DOM so the
              // detached viewer always shows the latest resource regardless of
              // how long the async InitializeScope HTTP calls took relative to
              // window.open() completing.
              if (scope['_reloadCurrent']) {
                scope['_reloadCurrent']();
              }

              $rootScope.$applyAsync();
            };

            const openWindow = () => {
              $window.current = childWindow = $window.open(attributes.template, '_blank', "menubar=no, status=no, toolbar=no, location=no, fullscreen=yes", false);
              childWindow.onload = initializeChildWindowAsync;
            };

            $rootScope.$watch(attributes.toggle, state => {
              if (state) {
                if (childWindow && !childWindow.closed) {
                  return;
                }
                openWindow();
              }
            });
          }
        };
      }
    }
  }

  frontendApp.directive("iioChildWindow", ["$rootScope", "$compile", "$window", "$templateCache", "$parse", Factory.Create(ChildWindow)]);
}
